export default __webpack_public_path__ + "static/media/gallery_01.94e48f47.jpg";